module.exports = __webpack_public_path__ + "fonts/Roboto-Black.d6a6f887.ttf";